import axios from "axios";

const ENDPOINTS = {
  USER_PROFILE: "/assets/v2/Me",
};

export class Starfleet {
  constructor(apiUrl, configs) {
    this.API_URL = apiUrl;
    this.configs = configs;
  }

  callStarfleetApi(endpoint, method, accessToken, dataObj) {
    const baseUrl = this.API_URL;

    return axios({
      method: method,
      baseURL: baseUrl,
      url: endpoint,
      data: JSON.stringify(dataObj),
      headers: {
        authorization: "Bearer " + accessToken,
        "content-type": "application/json",
      },
    });
  }

  getUserProfile(accessToken) {
    return this.callStarfleetApi(
      ENDPOINTS.USER_PROFILE,
      "GET",
      accessToken,
      {}
    ).then((response) => response.data);
  }

  getUserSession() {
    const sessionObject = JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEM));
    if (sessionObject && new Date(sessionObject.expiration) > new Date()) {
      return sessionObject;
    }
    const ssoSessionObject = JSON.parse(
      localStorage.getItem(localStorage.getItem(LAST_LOGIN))
    );
    if (
      ssoSessionObject &&
      DEFAULT_SUPPORTED_IDPS.includes(ssoSessionObject.idp_id) &&
      new Date(ssoSessionObject.expiration) > new Date()
    ) {
      return ssoSessionObject;
    }

    return {};
  }
}
export default Starfleet;
